import React from 'react';

function DateComposer(props) {
    const {
        date,
        setDate
    } = props;
    return (
        <div className="date-picker-container">
            <input
                type="date"
                className="custom-date-input"
                value={date}
                onChange={(event)=>{setDate(event.target.value)}}
            />
        </div>
    );
}

export default DateComposer;